/* Copyright (c) 2024 Xperi. All Rights Reserved. */

/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum MetadataState {
    AIRING_ERROR,
    AIRING_READY,
    ACTION_LIST_ERROR,
    ACTION_LIST_READY,
    ACTION_DETAILS_ERROR,
    ACTION_DETAILS_READY,
    DELETE_RECORDING_ERROR,
    DELETE_RECORDING_DONE,
    NONE,
    NDVR_LAST_VIEWED_POSITION_ERROR,
    NDVR_LAST_VIEWED_POSITION_READY,
    PREPARING,
    PREVIEW_ERROR,
    PREVIEW_READY,
    RECORDING_ACTION_ERROR,
    RECORDING_ACTION_INIT_READY,
    RECORDING_ACTION_READY,
    RECORDING_PREVIEW_ERROR,
    RECORDING_PREVIEW_READY,
    VOD_ACTION_ERROR,
    VOD_ACTION_READY,
    VOD_PREVIEW_ERROR,
    VOD_PREVIEW_READY,
    PLAY_NEXT_COLLECTION_ERROR,
    PLAY_NEXT_COLLECTION_READY,
    PLAY_NEXT_PREVIEW_ERROR,
    PLAY_NEXT_PREVIEW_READY,
    PLAY_NEXT_ACTIONS_ERROR,
    PLAY_NEXT_ACTIONS_READY,
}
